<template>
  <div class="gameplan">
    <div class="normal_box">
      <div class="item_detail select_item_red">
        <span v-if="item.needVerify==1">需要场勘 / </span>
        <span v-else>不需要场勘 / </span>
        <span v-if="item.needConstruct==1">需要搭建</span>
        <span v-else>不需要搭建</span>
      </div>
      <div class="item_detail"><span class="item_title">是否需要SPR  </span>{{item.needSpr==1?'是':'否'}}</div>
      <!-- <div class="item_detail"><span class="item_title">是否需要督导打卡  </span>{{item.needSupervisor==1?'是':'否'}}</div> -->
      <div class="item_detail" ><span class="item_title">是否需要转场 </span><span>{{item.needTransitions==1?'是':'否'}}</span></div>
      <div class="item_detail" v-if="item.themeDecorates"><span class="item_title">装饰点位  </span><span>{{getThemeDecorates(item.themeDecorates)}}</span></div>
      <div class="item_detail" v-if="item.pocCountMin>1"><span class="item_title">最少关联售点数 </span><span>{{item.pocCountMin}}</span></div>
      <!-- <div class="item_detail" v-if="getIgnate(item.igniteRuleObj)"><span class="item_title">IGNATE查询规则配置  </span><div class="ignate">{{getIgnate(item.igniteRuleObj)}}</div></div> -->
      <div class="item_detail"><span class="item_title">IGNITE查询规则配置  </span>
        <div class="ignite" v-if="igniteRuleDTOList&&igniteRuleDTOList.length>0">
          <div class="ignite-item" v-for="(item,index) of igniteRuleDTOList" :key="item.igniteRuleId">
            <div class="ignite-title">
              <div class="ignite-title-index" :span="4">规则限制{{index+1}}</div>
              <div :span="20" class="ignite-detail-box">
                (<div class="ignite-detail-bu" v-for="(buItem,buIndex) of item.igniteMappingDTOList" :key="buIndex"><span v-if="(buIndex!==0)">、</span>{{getName(buItem.buName)}}-{{getName(buItem.regionName)}}</div>)
              </div>
            </div>
            <el-row>
              <el-col :span="24">{{getIgnate(item.igniteRuleObj)}}</el-col>
            </el-row>
          </div>
        </div>
        <div v-else>无IGNITE查询规则限制</div>
      </div>
      <div class="item_detail" v-if="item.needTransitions==0"><span class="item_title">每{{ getUnits(item,'活动') }}执行活动天数 </span><span>{{item.perExecDays}}</span></div>
      <div class="item_detail" v-else><span class="item_title">道具数量设置 </span><span>{{item.itemQuantity}}</span></div>
      <div class="item_detail">
        <span class="item_title">
          <div>区域额度配置</div>
        </span>
        <div class="pr_operate_btn_white" v-if="(curAssignList&&curAssignList.length>0&&curAssignList[0].assignStatus!==100)" @click="gotoPage(item.themeId)">调整额度</div>
      </div>
      <div class="item_detail" v-for="(session,index) of submitAssignList" :key="session.assignItemKey">
        <span class="item_title">
          <div class="assign-detail">
            <div>总额度({{session.assignQty}}{{ getUnits(item) }})</div>
            <div>已分配({{getResult(index,session.assignQty)}}{{ getUnits(item) }})</div>
            <div>待分配({{session.assignQty - getResult(index)}}{{ getUnits(item) }})</div>
          </div>
        </span>
        <div v-if="assignList.length>0">
          <div v-if="buToCity===1&&employeeLevel>=60&&employeeLevel<90">
            <div v-for="itemList of assignList" class="region-city-item" :key="itemList[0].parentOrgName.split('|')[0]">
              <div class="bu-name"><div class="font-weight-bold">{{itemList[0].parentOrgName.split('|')[0]}}</div><div class="line"></div></div>
              <div class="display_flex">
                <ConfigDetailAssign ref="ConfigDetailAssignRef" @handleSubmit="handleSubmit" class="assign_item" v-for="item of itemList" :key="item.orgCode"
              :assignItem="item" :buToCity="buToCity" :srcAssignId="srcAssignId" :saveSubAssignList="saveSubAssignList"
              @handleAssign="handleAssign"></ConfigDetailAssign>
              </div>
            </div>
            <!-- <ConfigDetailAssign ref="ConfigDetailAssignRef" @handleSubmit="handleSubmit" class="assign_item" v-for="item of assignList" :key="item.orgCode"
            :assignItem="item"  :assignList="assignList" :assignAreaList="assignAreaList" :assignRegionList="assignRegionList" :buToCity="buToCity"></ConfigDetailAssign> -->
          </div>
          <div class="display_flex" v-else>
            <!-- <ConfigDetailAssign ref="ConfigDetailAssignRef" @handleSubmit="handleSubmit" class="assign_item" v-for="item of assignList" :key="item.orgCode"
            :assignItem="item"  :assignList="assignList" :assignAreaList="assignAreaList" :assignRegionList="assignRegionList" :buToCity="buToCity" :srcAssignId="session.assignId"
            :saveSubAssignList="saveSubAssignList" @handleAssign="handleAssign"></ConfigDetailAssign> -->
            <ConfigDetailAssignTransition ref="ConfigDetailAssignRef1" @handleSubmit="handleSubmit" :itemKey="index" :getSubAssignList="assignRegionList" class="assign_item" :assignAreaList="assignAreaList"
              :saveSubAssignList="session.subAssignList" :isFisrtConfig="false" :assignItemInfo="session" :srcAssignId="session.assignId" @handleSubmitAssign="handleSubmitAssign" :needTransitions="item.needTransitions"
            />
          </div>
        </div>
        <div class="tip" v-else>暂无可分配对象，请在城市池添加数据后再分配！</div>
      </div>
      <div v-show="isError" class="warning">待分配场数需大于等于0，请重新分配额度</div>
      <div v-show="showError" class="warning">请分配额度！</div>
    </div>
  </div>
</template>

<script>
// import ConfigDetailBu from './config-detail-assign.vue'
import { mapGetters } from 'vuex'
import { getDateFromString } from '@/filters'
import ConfigDetailAssign from './config-detail-assign.vue'
import ConfigDetailAssignTransition from './config-detail-assign-transition.vue'
export default {
  components:{
    ConfigDetailAssignTransition,
    ConfigDetailAssign
},
  props: {
    themeStyles1: {
      type: Object,
      default: () => { }
    },
    baseConfig: {
      type: Object,
      default: () => { }
    },
    secondTabItemName: {
      type: String,
      default: ''
    },
    fullConfig: { type: Array, default: () => [] },
    assignBuList:{ type: Array, default: () => [] },
    assignListParent:{ type: Array, default: () => [] },
    assignAreaList:{ type: Array, default: () => [] },
    assignRegionList: { type: Array, default: () => [] },
    igniteOptions: { type: Object, default: () => { } },
    saveDetailList: { type: Array, default: () => [] },
    allInfo: { type: Object, default: () => { } },
    detailListLength:{ type: Number, default: 0 },
    buToCity:{ type: Number, default: 0 },
  },
  data() {
    return {
      employeeLevel: '',
      hidden: false,
      radio: '',
      params: {
        needVerify: '',
        needConstruct: '',
        needSpr: '',
        themeDecorateCodes: [],
        pocCountMin: '',
        pocRelateType:2,
        igniteStatus:[],
        openStatus:[],
        channel:[],
        bizForm:[],
        pocGrade:[],
        salesVolume:[],
        igniteRuleObj: {
          igniteStatus:[],
        },
      },
      themeDetail:{},
      igniteRuleObj: {
        igniteStatus:['01'],
        region:''
      },
      editRules: {
        needSpr: [{ required: true, message: "请选择是或否", trigger: "blur" }],
        themeDecorateCodes: [{ required: true, message: "请选择装饰点位", trigger: "blur" }],
        pocCountMin: [{ required: true, message: "请输入售点数量", trigger: "blur" }],
        igniteStatus: [{ required: true, message: "请选择IGNITE状态", }],
        openStatus: [{ required: true, message: "请选择售点状态", trigger: "change" }],
        channel: [{ required: true, message: "请选择渠道设置", trigger: "change" }],
        bizForm: [{ required: true, message: "请选择业态", trigger: "change" }],
        pocGrade: [{ required: true, message: "请选择档次", trigger: "change" }],
        salesVolume: [{ required: true, message: "请选择销售潜力", trigger: "change" }],
        region: [
            { required: true, message: '请选择活动区域', trigger: 'change' }
          ],
      },
      radioList: [
        { key: '是', value: 1 },
        { key: '否', value: 0 },
      ],
      mandatoryDecorates: [],
      themeLevelsInfo: {},
      subAssignItem:{},
      subAssignList:[],
      assignBu:[],
      showDecorates:[],
      isSave:false,
      saveConfig:{},
      themeStyles:{},
      assignList:[],
      result:0,
      isError:false,
      showError:false,
      submitAssignList:[],
      igniteRuleDTOList:[]
    }
  },
  computed:{
    ...mapGetters(['userInfo']),
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    }
  },
  watch:{
    'assignList'(){

    },
    // 'buToCity'(val){
    //   this.result = 0
    //   this.isError = false
    //   if(this.isBU){
    //     this.assignList = []
    //     if(val==1){
    //       let itemIndex = []
    //       for(let item of this.assignAreaList){
    //         let index = itemIndex.indexOf(item.parentOrgId)
    //         if(index===-1){
    //           for(let parent of this.assignRegionList){
    //             if(item.parentOrgId===parent.orgId){
    //               item.parentOrgName = parent.orgName
    //               item.parentOrgCode = parent.orgId
    //               let data = [item]
    //               this.assignList.push(data)
    //               itemIndex.push(item.parentOrgId)
    //             }
    //           }
    //         }else {
    //           this.assignList[index].push(item)
    //         }
    //       }
    //     }else {
    //       this.assignList = this.assignRegionList || []
    //     }
    //     this.subAssignList = []
    //     this.saveSubAssignList = [] // 清除保存草稿的信息
    //   }
    // }
  },
  created() {
    this.assignList = [...this.assignListParent]
    this.employeeLevel = this.userInfo.employeeLevel
    if(this.employeeLevel>=90){
      this.assignList = this.assignBuList || []
    }else if(this.isBU){
      if(this.buToCity==0){
        this.assignList = this.assignRegionList || []
      }
    }else if(this.employeeLevel<60){
      this.assignList = this.assignAreaList
    }
    this.item = this.allInfo.themeDetail
    this.curAssignList = this.allInfo.curAssignList
    //this.item.quantity = (this.allInfo.curAssignList&&this.allInfo.curAssignList.assignQty)|| 0
    this.saveSubAssignList = this.allInfo.subAssignList
    this.igniteRuleDTOList = this.allInfo.igniteRuleDTOList
    //this.srcAssignId = (this.allInfo.curAssignList&&this.allInfo.curAssignList.assignId) || ''
    let assignItemKey = 0
    this.curAssignList.forEach(session => {
      let data = {...session}
      data.assignItemKey=assignItemKey
      data.needTransitions=this.item.needTransitions
      data.subAssignList=[]
      if(this.allInfo.subAssignMap){
        let keyList = Object.keys(this.allInfo.subAssignMap)
        for(let item of keyList){
          console.log(item);
          let dateList = item.split('至')
          if(session.assignStartTime==getDateFromString(dateList[0])&&session.assignEndTime==getDateFromString(dateList[1])){
            data.subAssignList=this.allInfo.subAssignMap[item]
          }
        }
      }
      this.submitAssignList.splice(this.submitAssignList.length,0,data)
      console.log(this.submitAssignList);
      assignItemKey++
    });
  },
  methods: {
    handleSubmitAssign(subAssignItem,assignItemKey){
      this.isError = false
      console.log(this.submitAssignList);
      console.log(subAssignItem,assignItemKey);
      let index =this.submitAssignList.findIndex(item=>{
        return item.assignItemKey === assignItemKey
      })
      if(index===-1){
        console.log("发现了问题！！");
        //this.submitAssignList.subAssignList.push(subAssignItem)
      }else {
        this.submitAssignList[index].subAssignList = subAssignItem
      }
      this.getResult(assignItemKey)
    },
    submit(type){
      // this.showError = false
      // if(this.$refs.ConfigDetailAssignRef&&this.$refs.ConfigDetailAssignRef.length>0){
      //   for(let i=0;i<this.$refs.ConfigDetailAssignRef.length;i++){
      //     this.$refs.ConfigDetailAssignRef[i].submit()
      //   }
      // }
      // if(type==='submit'){
      //   if(this.item.quantity - this.result<0){
      //     this.isError = true
      //     console.log("提交失败1");
      //     this.$emit("handleSubmit",data,false)
      //     return
      //   }
      //   if(this.subAssignList.length===0){
      //     //this.$message.warning("请填写分配信息后再操作！")
      //     console.log("提交失败2");
      //     this.showError = true
      //     this.$emit("handleSubmit",data,false)
      //     return
      //   }
      // }
      // this.isError = false
      if(this.isError) {
        this.$emit("handleSubmit",data,false)
        return
      }
      let submitAssignList = this.submitAssignList.map(session=>{
        session.subAssignList = session.subAssignList.map(buItem=>{
          buItem.assignStartTime = session.assignStartTime
          buItem.assignEndTime = session.assignEndTime
          return buItem
        })
        return session
      })
      console.log(submitAssignList);
      let subAssignList = submitAssignList.reduce((pre,cur)=>{
        return pre.concat(cur.subAssignList)
      },[])
      console.log(subAssignList)
      let data = {
        subAssignList:subAssignList,
        themeDetail:this.item,
        igniteRuleDTOList:this.allInfo.igniteRuleDTOList
      }
      console.log(data);
      this.$emit("handleSubmit",data,true)
    },
    getResult(assignItemKey,assignQty){
      let result = 0
      let index =this.submitAssignList.findIndex(item=>{
        return item.assignItemKey === assignItemKey
      })
      //console.log(index);
      if(index===-1){
        console.log("发现了问题！！");
        //this.submitAssignList.subAssignList.push(subAssignItem)
      }else {
        if(this.submitAssignList[index].subAssignList){
          result = this.submitAssignList[index].subAssignList.reduce((pre,cur)=>{
            return pre+Number(cur.assignQty)
          },0)
        }
      }
      ((assignQty-result)<0)?this.isError = true:''
      return result
    },
    getThemeDecorates(themeDecoratesList){
      let res = []
      for(let item of themeDecoratesList){
        res.push(item.decorateName)
      }
      return res.join('、')
    },
    gotoPage(themeId){
      this.$router.push({path:'/gameplan/quotaWait-confirmed-detail',query:{themeId}})
    },
    handleAssign(subAssignItem){
      if(this.isBU){
        if(this.subAssignList.length===0){
          console.log('subAssignList为空');
          this.subAssignList.push(subAssignItem)
        }else {
          let isExist = false
          for(let i=0;i<this.subAssignList.length;i++){
            if(this.buToCity==0){
              if(this.subAssignList[i].regionCode===subAssignItem.regionCode){
                console.log('找到了相同region');
                this.subAssignList.splice(i,1,subAssignItem)
                isExist = true
              }
            }else {
              if(this.subAssignList[i].areaCode===subAssignItem.areaCode){
                this.subAssignList.splice(i,1,subAssignItem)
                isExist = true
              }
            }
          }
          if(!isExist) {
            this.subAssignList.push(subAssignItem)
          }
        }
      }else if(this.isRegion){
        if(this.subAssignList.length===0){
          this.subAssignList.push(subAssignItem)
        }else {
          let isExist = false
          for(let i=0;i<this.subAssignList.length;i++){
            if(this.subAssignList[i].areaCode===subAssignItem.areaCode){
              this.subAssignList[i] = subAssignItem
              isExist = true
            }
          }
          if(!isExist) {
            this.subAssignList.push(subAssignItem)
          }
        }
      }
      let result = 0
      for(let item of this.subAssignList){
        result += Number(item.assignQty)
      }
      if(this.item.quantity - result===0){
        this.isError = false
      }
      this.result = result
    },
    handleSubmit(subAssignItem){
      // if(this.item.quantity - this.result!==0){
      //   this.isError = true
      //   return
      // }
      // this.isError = false
      // let data = {
      //   subAssignList:this.subAssignList,
      //   themeDetail:this.item
      // }
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    getUnits(item,extra){
      let units = ''
      if(item.needTransitions===0){
        switch (item.pocRelateType) {
          case '0':
          units = (extra?extra:'')+'地点'
            break;
          case '1':
          units = '售点'
            break;
          default:
          units = '街区'
            break;
        }
      }else {
        units = '场'
      }
      return units
    },
    getIgnate(igniteRuleObj){
      let res = ''
      for(let item in igniteRuleObj){
        let selectedList = igniteRuleObj[item]
        let detail = this.igniteOptions[item]
        if(selectedList&&selectedList.length>0){
          for(let selected of selectedList){
            switch (item) {
              case 'bizForm':
              res.indexOf('| 业态：')===-1?res+='| 业态：':res+=''
                //res+='业态：'
                break;
              case 'channel':
                res.indexOf('| 渠道设置：')===-1?res+='| 渠道设置：':res+=''
                break;
              case 'igniteStatus':
              res.indexOf('IGNATE状态：')===-1?res+='IGNATE状态：':res+=''
               // res+='IGNATE状态：'
                break;
              case 'openStatus':
              res.indexOf('售点状态：')===-1?res+='售点状态：':res+=''
               // res+='售点状态：'
                break;
              case 'pocGrade':
              res.indexOf('| 档次：')===-1?res+='| 档次：':res+=''
               // res+='档次：'
                break;
              case 'salesVolume':
              res.indexOf('| 销售潜力：')===-1?res+='| 销售潜力：':res+=''
                //res+='销售潜力：'
                break;
              default:
                break;
            }
            if(detail&&detail[selected]){
              res+= detail[selected] + " " + (item=="salesVolume"?"":"")
            }
          }
        }
      }
      return res
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep.el-radio {
  margin-right: 60px;

  .el-radio__input {
    display: inline-block;
    padding-right: 5px;

    &.is-checked .el-radio__inner {
      border-color: $base-red;
      background: $base-red;
    }

    &.is-checked+.el-radio__label {
      color: #101010;
    }
  }
}

::v-deep .el-form-item {
  margin: 3px 0;

  .el-form-item__label {
    color: black;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}

::v-deep .el-input__inner {
  width: 150px;
}
::v-deep .ignite_item_select .el-form-item__content {
  width: calc(100% - 180px);
}
::v-deep .ignite_item_select .el-select {
  margin: 0 20px 10px 0;
}
::v-deep .el-input__inner{
  height: 36px;
  line-height: 36px;
}
::v-deep .el-select {
  margin: 0 20px 20px 0;
}

.select_item_red {
    color: #e70027 !important;
    font-weight: bold;

}
.infoBox_cross_line_box {
  margin: 0px 0 20px 0;
  font-weight: 600;
  color: rgb(182, 182, 182);
  .infoBox_cross_line{
    width:800px;
    height: 1px;
    background-color: rgb(238, 238, 238);
    margin: -19px 0 0 120px;
  }
}
.display_block{
  display:block;
}
.el-form-item{
  width: 100%;
}
.display_flex{
    display: flex;
  }

.sp-el-form{
  width: 70%;
  position: relative;
  left: 180px;
  margin-top: -40px;
  display: flex;
  flex-wrap: wrap;
  // .el-form-item{
  // width: 150px;
  // margin:10px 15px 10px 0;
  // }
}
::v-deep .el-form-item__error{
  width: 150px;
}
::v-deep .ignite_item_select .el-select {
    margin: 0 20px 0px 0;
}

.item_title{
    display: inline-block;
    min-width: 200px;
    font-weight: 700;
    color: black;
  }
.assign-detail{
  margin-left: 30px;
  margin-top: 7px;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  color:#cd1231;
}
  .item_detail{
    //width: 900px;
    font-size: 15px;
    margin: 0px 15px 30px 15px;
    display: flex;
  }

  .region-city-item{
    width: 100%;
    margin-bottom:20px;
    .bu-name{
      width: 100%;
      margin-bottom: 15px;
    }
    .font-weight-bold{
      display:inline-block;
      font-weight: bold;
      font-size: 15px;
      width: 100px;
    }
    .line{
      display:inline-block;
      width: 650px;
      height: 1px;
      background-color:rgb(231, 231, 231);
      margin:-10px 0 0 30px;
    }
  }
.ignate{
  display: inline-block;
  width: calc(100% - 350px);
  line-height: 20px;
}
.warning{
  display: inline-block;
  margin-left: 220px;
  color: red;
}
.tip{
  color: #cd1231;
  font-weight: 600;
}
.ignite-title-index{
  font-weight: 600;
  min-width: 100px;
}
.ignite-title{
  display: flex;
  margin-bottom: 10px;
  width: 750px;
}
.item_assign_first_box{
  display: flex;
  flex-wrap: wrap;
}
.ignite-detail-box{
  display: flex;
  flex-wrap: wrap;
  color: #cd1231;
  font-weight: 500;
}
.ignite-item{
  margin-bottom: 30px;
}
.pr_operate_btn_white{
  color: rgb(214, 0, 0);
  text-align: center;
  padding: 5px 12px;
  margin-top: -5px;
  border-radius: 4px;
  background-color: white;
  border: 1px solid rgb(214, 0, 0);
  cursor: pointer;
}
</style>
